import React, { useEffect } from 'react';
import './Returnpolicy.css';

function Returnpolicy() {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div className="container my-5">
      <h2 className="body-font-bold mb-4 fs-3">Return, Refund & Exchange Policy</h2>
      <p className="mb-4">
        At <strong>PENTADECO</strong>, we strive to ensure that you are fully satisfied with every purchase. 
        However, if you are not completely happy with your order, our Return, Refund & Exchange Policy is 
        designed to help you shop with confidence.
      </p>

      <div className="content">
        <ol className="m-0">
          <li className="mb-4">
            <p className="fs-5 body-font-medium">Eligibility for Returns & Exchanges</p>
            <ol className="m-0" type="I">
              <li>
                <p className="text-muted">
                  <span className="body-font-medium text-black">Condition:</span> Products must be unused, 
                  unworn, and returned in original packaging with all tags, labels, and accessories intact.
                </p>
              </li>
              <li>
                <p className="text-muted">
                  <span className="body-font-medium text-black">Non-returnable items:</span> Personalized/customized products, 
                  clearance or sale items marked “Final Sale,” and opened/used personal accessories (for hygiene reasons).
                </p>
              </li>
            </ol>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">Return Window</p>
            <p className="text-muted">
              Returns/exchanges must be requested <strong>within 7 days of delivery</strong>. 
              Requests made after this period may not be accepted.
            </p>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">Return Process</p>
            <ol className="m-0" type="I">
              <li>
                <p className="text-muted">
                  <span className="body-font-medium text-black">Initiate:</span> Contact our support team via 
                  email or WhatsApp with your order number, reason for return, and photo/video proof (if defective/damaged).
                </p>
              </li>
              <li>
                <p className="text-muted">
                  <span className="body-font-medium text-black">Return Shipping:</span> 
                  - If due to defect/wrong item: We bear the cost.  
                  - If due to personal preference: Customer bears the cost.
                </p>
              </li>
            </ol>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">Refunds</p>
            <ol className="m-0" type="I">
              <li>
                <p className="text-muted">
                  <span className="body-font-medium text-black">Processing Time:</span> Refunds are processed within 
                  <strong> 7–10 working days </strong> after inspection and approval.
                </p>
              </li>
              <li>
                <p className="text-muted">
                  <span className="body-font-medium text-black">Method:</span> Refunds will be credited to the 
                  original payment method or as store credit.
                </p>
              </li>
              <li>
                <p className="text-muted">
                  <span className="body-font-medium text-black">Original Shipping:</span> Non-refundable unless return 
                  is due to our error/defective product.
                </p>
              </li>
            </ol>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">Exchanges</p>
            <p className="text-muted">
              Exchanges are available for defective/damaged products or size variations (if applicable). 
              If the replacement is out of stock, you may choose a refund or a different product of equal value.
            </p>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">Damaged/Defective or Incorrect Items</p>
            <p className="text-muted">
              If you receive a defective/incorrect product, notify us within <strong>48 hours of delivery</strong> 
              with order details and proof. We will arrange free pickup and replacement/refund.
            </p>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">Order Cancellations</p>
            <p className="text-muted">
              Orders can be cancelled <strong>before dispatch</strong>. Once dispatched, cancellations are not allowed. 
              You may still return after delivery as per this policy.
            </p>
          </li>

          <li className="mb-4">
            <p className="fs-5 body-font-medium">Contact Information</p>
            <p className="text-muted">For return, refund, or exchange requests, contact:</p>
            <p className="mb-0">PENTADECO Customer Care</p>
            <p className="mb-0">
              Email:{" "}
              <a href="mailto:pentadeco@gmail.com" className="nav-link d-inline text-primary">
                pentadeco@gmail.com
              </a>
            </p>
            <p className="mb-0">
              WhatsApp:{" "}
              <a href="tel:+917738494171" className="nav-link d-inline text-primary">+91 7738494171</a> |{" "}
              <a href="tel:+918433551012" className="nav-link d-inline text-primary">+91 8433551012</a> |{" "}
              <a href="tel:+919273158535" className="nav-link d-inline text-primary">+91 9273158535</a>
            </p>
          </li>
        </ol>
      </div>
    </div>
  );
}

export default Returnpolicy;
